._image_1x1y7_1 {
  padding-bottom: 18px; }

._image_1x1y7_1 img {
  display: block;
  width: 100%;
  border: none; }
